module.exports = __webpack_public_path__ + "static/FY_2023_Investor_Presentation-6f818c9ca6cedf44f23945f1df8d4dc4.pdf";